/* eslint-disable */
import React, { useState } from 'react';
import {
    Grid,
    Typography,
    RACButton,
    RACModalCard,
} from '@rentacenter/racstrap';
import { ReactComponent as AlertIcon } from './../images/no-records-found.svg';
import { VerificationStyles } from "./../JSStyles/verificationStyles";
import { useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface LocationState {
    errorMessage?: string;
}

const LivelinessCheckFailed: React.FC = () => {
    const [livelinessCheckFailed, setLivelinessCheckFailed] = useState<boolean>(true)

    const verificationStyles: any = VerificationStyles();
    const { t } = useTranslation();

    const history = useHistory();
    const location = useLocation<LocationState>();
    const errorMessage = location.state?.errorMessage;
    console.log('Error Message check - ',location,errorMessage);
    
    const LivelinessCheckFailed = () => {
        return (<div
            id="initialpayment"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            aria-hidden="true"
        >
            <Grid className={verificationStyles.centerAlign}>
                <AlertIcon></AlertIcon>
                <Typography className={`  ${verificationStyles.mt10px}`} style={{
                    fontFamily: 'OpenSans-bold',
                    fontSize: "20px",
                    marginBottom: '0.2rem',
                    color: '#000'
                }}>
                    {t('Liveliness Check Failed')}
                </Typography>

                {errorMessage && (
                    <Typography className={`${verificationStyles.formLabel} ${verificationStyles.mt10px}`} style={{ fontFamily: 'OpenSans-semibold', color: '#d32f2f' }}>
                        {errorMessage}
                    </Typography>
                )}

                <Typography className={`${verificationStyles.formLabel}  ${verificationStyles.mt10px}`} style={{ fontFamily: 'OpenSans-semibold' }}>
                    {t('The liveliness check was not successful. To continue, please upload a clear photo of your face for manual verification.')}
                </Typography>
            </Grid>
            <Grid
                item
                md={12}
                className={`${verificationStyles.mt20px} ${verificationStyles.pb4} ${verificationStyles.centerAlign}`}
            >
                <RACButton
                    className={verificationStyles.mx1}
                    variant="contained"
                    color="primary"
                    onClick={() => {
                        history.push(`/selfieupload`);
                        setLivelinessCheckFailed(false)
                    }}
                >
                    {t("Proceed")}
                </RACButton>
            </Grid>
        </div>)
    }

    return (
        <>

            <RACModalCard
                borderRadius="15px"
                closeIcon={false}
                isOpen={livelinessCheckFailed}
                maxWidth={'sm'}
                onClose={() => setLivelinessCheckFailed(false)}
            >
                {LivelinessCheckFailed()}
            </RACModalCard>
        </>
    )

};

export default LivelinessCheckFailed;